import { Button, Col, Row, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { FaFileExport } from "react-icons/fa";
import { BiRefresh } from "react-icons/bi";

const { Text } = Typography;

interface FACTProps {
  totalDocumentsReadyFact: number;
  refetchFact: () => void;
  isLoadingReadyFACT: boolean;
  onExport: () => void;
  isExporting: boolean;
}

export default function FACT({
  totalDocumentsReadyFact,
  refetchFact,
  isLoadingReadyFACT,
  onExport,
  isExporting,
}: FACTProps) {
  const { t } = useTranslation();

  const hasDocuments = totalDocumentsReadyFact > 0;

  return (
    <Row justify="space-between" align="middle">
      <Col>
        <Space size={8} align="baseline">
          {hasDocuments ? (
            <>
              <Text strong style={{ fontSize: 24, color: "#3e849e" }}>
                {totalDocumentsReadyFact}
              </Text>
              <Text type="secondary" style={{ fontSize: 14 }}>
                {t("documentsReadyForExport")}
              </Text>
            </>
          ) : (
            <Text type="secondary" style={{ fontSize: 14 }}>
              {t("There are no documents to export")}
            </Text>
          )}
        </Space>
      </Col>
      <Col>
        <div className="fact-export-actions">
          <Button
            className="fact-export-actions__button fact-export-actions__button--refresh"
            onClick={() => refetchFact()}
            loading={isLoadingReadyFACT}
            onMouseLeave={e => e.currentTarget.blur()}
            icon={<BiRefresh />}
          >
            {t("Refresh")}
          </Button>
          <div className="fact-export-actions__divider" />
          <Button
            className="fact-export-actions__button fact-export-actions__button--export"
            onClick={onExport}
            loading={isExporting}
            disabled={!hasDocuments}
            onMouseLeave={e => e.currentTarget.blur()}
            icon={<FaFileExport />}
          >
            {t("Export")}
          </Button>
        </div>
      </Col>
    </Row>
  );
}
